import { getCircular } from "../Service/Api";
import React, { useState, useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import AchievementsData from "./AchievementsData";

const Achievements = () => {
  useEffect(() => {
    document.title = "Achievements- The Air Force School Subroto Park";
  }, []);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("All");
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true); // Loading state
  // Function to get the fiscal year based on April to April range
  const getFiscalYear = (date) => {
    const month = new Date(date).getMonth() + 1; // Get month (1-based)
    const year = new Date(date).getFullYear();

    // Log to verify fiscal year calculation
    console.log(
      `Date: ${date}, Month: ${month}, Fiscal Year: ${month < 4 ? year - 1 : year}`,
    );

    if (month < 4) {
      return year - 1; // If before April, it's considered the previous fiscal year
    }

    return year; // Otherwise, it's the current fiscal year
  };

  // Fetch data and process year/month ranges
  useEffect(() => {
    const fetchData = async () => {
      const allData = await getCircular(); // Assuming getCircular() fetches your data
      const galleryData = allData.filter(
        (item) => item.school === "Senior" && item.category === "Achievements",
      );

      console.log("Fetched Gallery Data:", galleryData); // Log fetched data

      setData(galleryData);
      setFilteredData(galleryData);

      // Calculate the fiscal years available in the data
      const yearsWithData = Array.from(
        new Set(
          galleryData
            .filter((item) => item.date && !isNaN(new Date(item.date))) // Ensure the date is valid
            .map((item) => getFiscalYear(item.date)),
        ),
      );

      console.log("Years with data:", yearsWithData); // Log years derived from the data

      const yearOptions = yearsWithData
        .map((year) => `${year} - ${year + 1}`)
        .sort((a, b) => parseInt(b) - parseInt(a)); // Sort descending

      console.log("Year options:", yearOptions); // Log the final year options

      setYearRanges(yearOptions);
      setSelectedYear(yearOptions[0]);
      setLoading(false);
    };

    fetchData();
  }, []); // Run on component mount

  // Filter data based on selected filters
  useEffect(() => {
    let filteredData = data;

    // If selectedYear is 'All', skip filtering by year
    if (selectedYear !== "All") {
      const [startYear, endYear] = selectedYear.split(" - ").map(Number);
      filteredData = filteredData.filter((item) => {
        if (item.date && item.date.trim() !== "") {
          const fiscalYear = getFiscalYear(item.date);
          return fiscalYear === startYear;
        }
        return false;
      });
    }

    // Filter by search query
    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    // Sort the filtered data by fiscal year and date in descending order
    filteredData.sort((a, b) => {
      const fiscalYearA = getFiscalYear(a.date);
      const fiscalYearB = getFiscalYear(b.date);
      if (fiscalYearA === fiscalYearB) {
        return new Date(b.date) - new Date(a.date); // Sort by date descending if years are the same
      }
      return fiscalYearB - fiscalYearA; // Sort by fiscal year descending
    });

    // Log the filtered data
    console.log("Filtered Data after applying all filters:", filteredData);

    // Set filtered data
    setFilteredData(filteredData);
  }, [selectedYear, searchQuery, data]);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>Achievements</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Achievements</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="chooseyear">
                <select
                  id="chooseddlYear"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  {yearRanges.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                  <option value="Archive">Archive</option>
                </select>
              </div>
              <div className="clr"></div>
              <div className="row achievementlist">
                <ul className="list">
                  {loading ? (
                    <div>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/loading.gif"
                        className="img-fluid loadingimg"
                      />
                    </div>
                  ) : filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                      <li key={index}>
                        <Link
                          to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                          target="_blank"
                        >
                          <div
                            dangerouslySetInnerHTML={{ __html: item.title }}
                          />{" "}
                          - <b>Click Here</b>
                        </Link>
                      </li>
                    ))
                  ) : (
                    <p> </p>
                  )}
                </ul>
              </div>

              {selectedYear === "Archive" && <AchievementsData />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Achievements;
